<template>
  <div class="tabs-section">
    <div
      class="tab-item"
      :class="{ 'item-active': tabValue == item.value }"
      v-for="(item, index) in tabsList"
      :key="index"
      @click="handleClickItem(item)"
    >
      <span class="tab-icon">
        <operation-icon :name="item.icon"></operation-icon>
      </span>
      <span class="tab-copy">
        <strong>{{ item.label }}</strong>
        <small v-if="item.subtitle">{{ item.subtitle }}</small>
      </span>
      <span class="tab-arrow" aria-hidden="true">
        <svg viewBox="0 0 16 16" fill="none">
          <path d="M6 4.5L9.5 8 6 11.5" />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
import OperationIcon from "./operation-icon.vue";

export default {
  components: { OperationIcon },
  props: {
    defaultIndex: {
      type: String,
      default: "1",
    },
    tabsList: {
      type: Array,
      default: () => [
        {
          value: "1",
          label: "标签一",
        },
        {
          value: "2",
          label: "标签二",
        },
        {
          value: "3",
          label: "标签三",
        },
      ],
    },
  },
  watch: {
    defaultIndex() {
      this.tabValue = this.defaultIndex;
    },
  },
  data() {
    return {
      tabValue: "1",
    };
  },
  mounted(){
    this.tabValue = this.defaultIndex
  },
  methods: {
    handleClickItem(item) {
      this.tabValue = item.value;
      this.$emit('changeTabValueAction', this.tabValue)
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-section {
  width: 100%;
  min-height: 90px;
  margin-top: 28px;
  box-sizing: border-box;
  padding: 12px 22px;
  display: flex;
  gap: 12px;
  border: 1px solid #e5ebf3;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 10px 28px rgba(18, 68, 145, 0.07);

  .tab-item {
    min-width: 0;
    min-height: 66px;
    flex: 1;
    padding: 10px 18px;
    display: flex;
    align-items: center;
    gap: 14px;
    position: relative;
    color: #1d1d1d;
    border: 1px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s, color 0.2s, background 0.2s;

    &:not(:last-child)::after {
      content: "";
      width: 1px;
      height: 44px;
      position: absolute;
      right: -7px;
      top: 50%;
      background: #e4e9f0;
      transform: translateY(-50%);
    }
  }

  .item-active {
    color: #1f63ea;
    border-color: #1f63ea;
    background: linear-gradient(135deg, #f5f9ff, #fff);

    &::after {
      display: none;
    }

    .tab-icon {
      color: #fff;
      background: linear-gradient(135deg, #1f63ea, #5b92ff);
    }

    .tab-arrow {
      color: #fff;
      background: #1f63ea;
    }
  }

  .tab-icon {
    width: 44px;
    height: 44px;
    flex: none;
    display: grid;
    place-items: center;
    box-sizing: border-box;
    padding: 9px;
    color: #1f63ea;
    border-radius: 12px;
    background: #edf4ff;
  }

  .tab-copy {
    min-width: 0;
    flex: 1;

    strong,
    small {
      display: block;
    }

    strong {
      margin-bottom: 7px;
      font-size: 18px;
      font-weight: 500;
    }

    small {
      overflow: hidden;
      color: #7d8797;
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .tab-arrow {
    width: 28px;
    height: 28px;
    flex: none;
    display: grid;
    place-items: center;
    color: #8a94a3;
    border-radius: 50%;
    background: #f2f4f7;

    svg {
      width: 14px;
      height: 14px;
      display: block;
      stroke: currentColor;
      stroke-width: 1.8;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
}

@media (max-width: 1440px) {
  .tabs-section {
    gap: 8px;
    padding: 12px 14px;

    .tab-item {
      gap: 10px;
      padding: 10px 12px;

      &:not(:last-child)::after {
        right: -5px;
      }
    }

    .tab-icon {
      width: 40px;
      height: 40px;
      padding: 8px;
    }

    .tab-copy strong {
      font-size: 16px;
      white-space: nowrap;
    }

    .tab-arrow {
      display: none;
    }
  }
}

@media (max-width: 900px) {
  .tabs-section {
    width: 780px;

    .tab-item {
      flex: 0 0 240px;
    }
  }
}
</style>
